import LuvitComponent from "LuvitComponent";
import React from "react";
import { autobind } from "lib/decorators";
import { GET } from "lib/api";
import config from "lib/config";

var personalId = config.personalId;

export default class CopyableAssessments extends LuvitComponent {
  constructor(props, context) {
    super(props, context, "NavigationTree");
  }

  async componentWillMount() {
    let assessments = await GET(`v1/users/${personalId}/copyable-assessments`);

    let selectedAssessment;
    if (this.props["hf-element"])
      selectedAssessment = document.getElementById(
        this.props["hf-element"],
      ).value;

    if (!selectedAssessment) {
      selectedAssessment = assessments[0].assessmentID;
      this.setServerValue(selectedAssessment);
    }

    this.setState({ assessments, selectedAssessment });
  }

  @autobind
  setServerValue(selectedAssessment) {
    if (this.props["hf-element"])
      document.getElementById(this.props["hf-element"]).value =
        selectedAssessment;
  }

  @autobind
  OnAssessmentChange() {
    if (!this.refs || !this.refs.select) return;

    let selectedAssessment = this.refs.select.value;

    this.setServerValue(selectedAssessment);

    this.setState({ selectedAssessment });
  }

  doRender() {
    if (!this.state || !this.state.assessments) return <div />;

    return (
      <div>
        <span>{this.l("assessmenttocopy")}: &nbsp;</span>
        <select
          ref="select"
          onChange={this.OnAssessmentChange}
          value={this.state.selectedAssessment}
        >
          {this.state.assessments.map((a) => (
            <option value={a.assessmentID}>{a.title}</option>
          ))}
        </select>
      </div>
    );
  }
}
